export async function strapiData(
  JWT: string,
  api: string,
  param?: string,
  documentId?: string,
  nocache?: true,
  revalidate?: number,
  limit?: number, // max 300 as this is first page size
  cacheTags?: string[],
) {
  let url;
  let params: any = {
    headers: {
      Authorization: `Bearer ${JWT}`,
    },
    cache: nocache ? "no-cache" : "force-cache",
  };
  const nextOpts: { revalidate?: number; tags?: string[] } = {};
  if (revalidate) {
    params.cache = undefined;
    nextOpts.revalidate = revalidate;
  }
  if (cacheTags != null && cacheTags.length > 0) {
    params.cache = undefined;
    nextOpts.tags = cacheTags;
  }
  if (Object.keys(nextOpts).length > 0) {
    params.next = nextOpts;
  }

  // Function to fetch a single page
  const fetchPage = async (page: number) => {
    const pageParam = `pagination[page]=${page}&pagination[pageSize]=300`;
    const fullParam = param ? `${param}&${pageParam}` : pageParam;

    if (documentId) {
      url = `${process.env.NEXT_PUBLIC_STRAPI_BASE_URL}/${api}/${documentId}?${fullParam}`;
    } else {
      url = `${process.env.NEXT_PUBLIC_STRAPI_BASE_URL}/${api}?${fullParam}`;
    }

    let attempts = 0;
    while (attempts < 3) {
      try {
        const res = await fetch(url, params);
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        const response = await res.json();
        return {
          data: response.data,
          meta: response.meta,
        };
      } catch (error) {
        attempts++;
        await new Promise((resolve) => setTimeout(resolve, 5000));
        console.error(
          `Attempt ${attempts} failed for ${url.slice(0, 50)}, retrying...`
        );
        if (attempts === 3) {
          console.error(`Failed to fetch data for ${url}`);
          return { data: [], meta: { pagination: { total: 0, pageCount: 0 } } };
        }
      }
    }
    return { data: [], meta: { pagination: { total: 0, pageCount: 0 } } };
  };

  // Fetch first page to get total count
  const firstPage = await fetchPage(1);
  // if a custom response/fetch to Strapi just return it
  if (!firstPage.meta || Object.keys(firstPage.meta).length === 0) {
    return firstPage.data;
  }
  // if limit supplied, return that number
  if (limit) {
    return firstPage.data.slice(0, limit);
  }
  // otherwise fetch all pages
  const { pageCount } = firstPage.meta.pagination;
  let allData = [...firstPage.data];

  // If there are more pages, fetch them
  if (pageCount > 1) {
    const remainingPages = Array.from(
      { length: pageCount - 1 },
      (_, i) => i + 2
    );

    const remainingData = await Promise.all(
      remainingPages.map((page) => fetchPage(page))
    );

    allData = allData.concat(remainingData.flatMap((page) => page.data));
  }
  return allData;
}

export function handleResponseError(response: any) {
  return response.msg === "fetch failed"
    ? process.env.NEXT_PUBLIC_SERVER_DOWN
    : response.msg;
}
